import React from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

const errorMessages = {
  metricSampleSize: "Please enter an integer greater than or equal to 10",
};

const MetricOption = (props) => {
  const { options, setOptions } = props;

  const errorMessage = () => {
    let errorFound = false;
    for (let error in props.errors) {
      if (error.includes("metric") && !errorFound) {
        errorFound = true;
        return (
          <p style={{ color: "red", fontSize: "10px" }}>
            {errorMessages[error]}
          </p>
        );
      }
    }
  };

  const validations = (sampleSize, metricType) => {
    if (metricType === "snapshot") {
      props.noErrorDetected("metricSampleSize");
      return;
    }
    let currentSampleSize =
      sampleSize != null ? Number(sampleSize) : Number(options.metric.samples);
    if (sampleSize === "") {
      currentSampleSize = null;
    }
    if (sampleSize < 10 || !Number.isInteger(currentSampleSize)) {
      props.errorDetected("metricSampleSize");
    } else {
      props.noErrorDetected("metricSampleSize");
    }
  };

  return (
    <FormControl
      variant="standard"
      fullWidth={true}
      style={{
        flexDirection: "column",
        margin: 24,
        width: "calc(100% - 48px)",
      }}
    >
      <FormLabel
        style={{ fontSize: 14, fontStyle: "italic" }}
        component="legend"
      >
        Metric
      </FormLabel>
      <FormControl
        variant="standard"
        fullWidth={true}
        style={{ margin: 6, flexDirection: "row", alignItems: "flex-end" }}
      >
        <TextField
          sx={{ marginLeft: 1, marginRight: 1, width: "50%" }}
          id="select-metric-type"
          label="Metric Type"
          select
          value={options.metric.type}
          onChange={(event) => {
            setOptions({
              metric: {
                ...options.metric,
                type: event.target.value,
              },
            });
            validations(options.metric.samples, event.target.value);
          }}
          margin="normal"
          variant="filled"
          SelectProps={{
            sx: { backgroundColor: "transparent" },
          }}
        >
          <MenuItem key="metric-snapshot" value="snapshot">
            Snapshot
          </MenuItem>
          {/* <MenuItem key="metric-average" value="average">
            Average
          </MenuItem> */}
          <MenuItem key="metric-maximum" value="max">
            Maximum
          </MenuItem>
          <MenuItem key="metric-minimum" value="min">
            Minimum
          </MenuItem>
        </TextField>
        {options.metric.type !== "snapshot" && (
          <TextField
            variant="standard"
            sx={{ marginLeft: 1, marginRight: 1, width: "50%" }}
            id="metric-samples"
            label="Over number of samples"
            value={options.metric.samples}
            onChange={(event) => {
              setOptions({
                metric: {
                  ...options.metric,
                  samples: event.target.value,
                },
              });
              validations(event.target.value, options.metric.type);
            }}
            type="number"
            InputLabelProps={{ shrink: true }}
            margin="normal"
          />
        )}
      </FormControl>
      {errorMessage()}
    </FormControl>
  );
};

export default MetricOption;
